"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _variables = require("../common/variables.js");

var _useTheme = _interopRequireDefault(require("../useTheme"));

var _useTranslatedLabels = _interopRequireDefault(require("../useTranslatedLabels"));

var _BackgroundColorContext = require("../BackgroundColorContext");

var _Icons = require("./Icons");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DxcFooter = function DxcFooter(_ref) {
  var socialLinks = _ref.socialLinks,
      bottomLinks = _ref.bottomLinks,
      copyright = _ref.copyright,
      children = _ref.children,
      padding = _ref.padding,
      margin = _ref.margin,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex;
  var colorsTheme = (0, _useTheme["default"])();
  var translatedLabels = (0, _useTranslatedLabels["default"])();
  var footerLogo = (0, _react.useMemo)(function () {
    if (!colorsTheme.footer.logo) {
      return _Icons.dxcLogo;
    }

    if (typeof colorsTheme.footer.logo === "string") {
      return /*#__PURE__*/_react["default"].createElement(LogoImg, {
        alt: translatedLabels.formFields.logoAlternativeText,
        src: colorsTheme.footer.logo
      });
    }

    return colorsTheme.footer.logo;
  }, [colorsTheme.footer.logo]);
  var socialLink = socialLinks === null || socialLinks === void 0 ? void 0 : socialLinks.map(function (link, index) {
    return /*#__PURE__*/_react["default"].createElement(SocialAnchor, {
      tabIndex: tabIndex,
      key: "social".concat(index).concat(link.href),
      index: index,
      href: link && link.href ? link.href : ""
    }, /*#__PURE__*/_react["default"].createElement(SocialIconContainer, null, typeof link.logo === "string" ? /*#__PURE__*/_react["default"].createElement(SocialIconImg, {
      src: link.logo
    }) : link.logo));
  });
  var bottomLink = bottomLinks === null || bottomLinks === void 0 ? void 0 : bottomLinks.map(function (link, index) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      key: "bottom".concat(index).concat(link.text)
    }, /*#__PURE__*/_react["default"].createElement(BottomLink, {
      tabIndex: tabIndex,
      href: link && link.href ? link.href : ""
    }, link && link.text ? link.text : ""), /*#__PURE__*/_react["default"].createElement(Point, {
      index: index
    }, "\xB7"));
  });
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: colorsTheme.footer
  }, /*#__PURE__*/_react["default"].createElement(FooterContainer, {
    margin: margin
  }, /*#__PURE__*/_react["default"].createElement(FooterHeader, null, /*#__PURE__*/_react["default"].createElement(LogoContainer, null, footerLogo), /*#__PURE__*/_react["default"].createElement(SocialLinkContainer, null, socialLink)), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(ChildComponents, {
    padding: padding
  }, /*#__PURE__*/_react["default"].createElement(_BackgroundColorContext.BackgroundColorProvider, {
    color: colorsTheme.footer.backgroundColor
  }, children)), /*#__PURE__*/_react["default"].createElement(FooterFooter, {
    className: "footerFooter"
  }, /*#__PURE__*/_react["default"].createElement(BottomLinks, null, bottomLink), /*#__PURE__*/_react["default"].createElement(Copyright, null, copyright || translatedLabels.footer.copyrightText(new Date().getFullYear()))))));
};

var FooterContainer = _styledComponents["default"].footer(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  @media (min-width: ", "rem) {\n    padding: 24px 36px 24px 36px;\n  }\n\n  @media (max-width: ", "rem) {\n    //mobile phones\n    padding: 20px;\n  }\n\n  background-color: ", ";\n  margin-top: ", ";\n  width: 100%;\n  box-sizing: border-box;\n  min-height: ", ";\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n"])), _variables.responsiveSizes.small, _variables.responsiveSizes.small, function (props) {
  return props.theme.backgroundColor;
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) !== "object" ? _variables.spaces[props.margin] : "0px";
}, function (props) {
  return props.theme.height;
});

var FooterHeader = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  row-gap: 24px;\n"])));

var FooterFooter = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n\n  @media (min-width: ", "rem) {\n    flex-direction: row;\n  }\n\n  @media (max-width: ", "rem) {\n    //mobile phones\n    flex-direction: column;\n    align-items: center;\n  }\n\n  border-top: ", ";\n  margin-top: 16px;\n"])), _variables.responsiveSizes.small, _variables.responsiveSizes.small, function (props) {
  return "".concat(props.theme.bottomLinksDividerThickness, " ").concat(props.theme.bottomLinksDividerStyle, " ").concat(props.theme.bottomLinksDividerColor);
});

var BottomLinks = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  padding-top: ", ";\n  display: inline-flex;\n  flex-wrap: wrap;\n\n  @media (min-width: ", "rem) {\n    max-width: 60%;\n  }\n\n  @media (max-width: ", "rem) {\n    //mobile phones\n    max-width: 100%;\n    width: 100%;\n  }\n\n  & > span:last-child span {\n    display: none;\n  }\n  align-self: center;\n"])), function (props) {
  return props.theme.bottomLinksDividerSpacing;
}, _variables.responsiveSizes.small, _variables.responsiveSizes.small);

var ChildComponents = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  min-height: 16px;\n  padding: ", ";\n  padding-top: ", ";\n  padding-right: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n  overflow: hidden;\n"])), function (props) {
  return props.padding && (0, _typeof2["default"])(props.padding) !== "object" ? _variables.spaces[props.padding] : "0px";
}, function (props) {
  return props.padding && (0, _typeof2["default"])(props.padding) === "object" && props.padding.top ? _variables.spaces[props.padding.top] : "";
}, function (props) {
  return props.padding && (0, _typeof2["default"])(props.padding) === "object" && props.padding.right ? _variables.spaces[props.padding.right] : "";
}, function (props) {
  return props.padding && (0, _typeof2["default"])(props.padding) === "object" && props.padding.bottom ? _variables.spaces[props.padding.bottom] : "";
}, function (props) {
  return props.padding && (0, _typeof2["default"])(props.padding) === "object" && props.padding.left ? _variables.spaces[props.padding.left] : "";
});

var Copyright = _styledComponents["default"].div(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  font-family: ", ";\n  font-size: ", ";\n  font-style: ", ";\n  font-weight: ", ";\n  color: ", ";\n\n  @media (min-width: ", "rem) {\n    max-width: 40%;\n    text-align: right;\n  }\n\n  @media (max-width: ", "rem) {\n    //mobile phones\n    max-width: 100%;\n    width: 100%;\n    text-align: left;\n  }\n\n  padding-top: ", ";\n"])), function (props) {
  return props.theme.copyrightFontFamily;
}, function (props) {
  return props.theme.copyrightFontSize;
}, function (props) {
  return props.theme.copyrightFontStyle;
}, function (props) {
  return props.theme.copyrightFontWeight;
}, function (props) {
  return props.theme.copyrightFontColor;
}, _variables.responsiveSizes.small, _variables.responsiveSizes.small, function (props) {
  return props.theme.bottomLinksDividerSpacing;
});

var LogoContainer = _styledComponents["default"].div(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  max-height: ", ";\n  width: ", ";\n"])), function (props) {
  return props.theme.logoHeight;
}, function (props) {
  return props.theme.logoWidth;
});

var LogoImg = _styledComponents["default"].img(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n  max-height: ", ";\n  width: ", ";\n"])), function (props) {
  return props.theme.logoHeight;
}, function (props) {
  return props.theme.logoWidth;
});

var SocialLinkContainer = _styledComponents["default"].div(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  align-self: center;\n"])));

var SocialAnchor = _styledComponents["default"].a(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2["default"])(["\n  & {\n    display: inline-flex;\n    margin-left: ", ";\n  }\n"])), function (props) {
  return props.index === 0 ? "0px" : props.theme.socialLinksGutter;
});

var SocialIconImg = _styledComponents["default"].img(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2["default"])([""])));

var SocialIconContainer = _styledComponents["default"].div(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2["default"])(["\n  & {\n    display: inline-flex;\n    height: ", ";\n    width: ", ";\n    color: ", ";\n  }\n\n  overflow: hidden;\n  img,\n  svg {\n    height: 100%;\n    width: 100%;\n  }\n"])), function (props) {
  return props.theme.socialLinksSize;
}, function (props) {
  return props.theme.socialLinksSize;
}, function (props) {
  return props.theme.socialLinksColor;
});

var Point = _styledComponents["default"].span(_templateObject13 || (_templateObject13 = (0, _taggedTemplateLiteral2["default"])(["\n  margin: 0px 10px;\n  color: ", ";\n"])), function (props) {
  return props.theme.bottomLinksFontColor;
});

var BottomLink = _styledComponents["default"].a(_templateObject14 || (_templateObject14 = (0, _taggedTemplateLiteral2["default"])(["\n  text-decoration: ", ";\n  color: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  font-style: ", ";\n  font-weight: ", ";\n"])), function (props) {
  return props.theme.bottomLinksTextDecoration;
}, function (props) {
  return props.theme.bottomLinksFontColor;
}, function (props) {
  return props.theme.bottomLinksFontFamily;
}, function (props) {
  return props.theme.bottomLinksFontSize;
}, function (props) {
  return props.theme.bottomLinksFontStyle;
}, function (props) {
  return props.theme.bottomLinksFontWeight;
});

var _default = DxcFooter;
exports["default"] = _default;